import { render, staticRenderFns } from "./promociones.vue?vue&type=template&id=3fe760b2&scoped=true"
import script from "./promociones.vue?vue&type=script&lang=js"
export * from "./promociones.vue?vue&type=script&lang=js"
import style0 from "./promociones.vue?vue&type=style&index=0&id=3fe760b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe760b2",
  null
  
)

export default component.exports